// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5b61cd98","453":"5648917e","667":"dd49b551"}[chunkId] + ".chunk.js";
};